import VerifiedIcon from "../../../../../assets/vector/VerifiedCustomIcon.svg";
import {useTranslation} from "react-i18next";
import {Box, styled} from "@mui/material";

interface Icon{
  label: string;
  component: any
}

const VerifiedObject = styled('object')(() => ({
  filter: 'invert(99%) sepia(47%) saturate(2196%) hue-rotate(32deg) brightness(91%) contrast(88%)'
}))

const UnverifiedObject = styled('object')(() => ({
  filter: 'invert(69%) sepia(11%) saturate(204%) hue-rotate(172deg) brightness(93%) contrast(81%)'
}))

const DenyObject = styled('object')(() => ({
  filter: 'invert(73%) sepia(19%) saturate(7466%) hue-rotate(334deg) brightness(100%) contrast(104%)'
}))

function CustomVerifiedIcon({value}: {value: number}) {
  const { t } = useTranslation(['global'])

  const icons: Icon[] = [
    {label: t('admin.people.unverified'), component: UnverifiedObject},
    {label: t('admin.people.verified'), component: VerifiedObject},
    {label: t('admin.people.unverified'), component: UnverifiedObject},
    {label: t('deny'), component: DenyObject },
  ]

  const DynamicObject = icons[value].component
  return (
    <Box pl={4} pt={1}>
      <DynamicObject data={VerifiedIcon} aria-label={icons[value].label} />
    </Box>
  )
}

export default CustomVerifiedIcon
